import { computed, observable } from 'mobx';

export abstract class AbstractStore {
    @observable
    private hasLoadedData = false;
    @observable
    private isUpdating = false;

    @computed
    public get storeIsReady(): boolean {
        return this.hasLoadedData;
    }

    @computed
    public get storeIsUpdating(): boolean {
        return this.isUpdating;
    }

    protected abstract loadData(): Promise<void>;

    public initializeStore(): Promise<void> {
        return this.loadData()
            .then(() => {
                this.hasLoadedData = true;
            })
            .catch(err => {
                console.log('initializeStore err: ', err);
                throw err;
            });
    }

    protected updateStore(): Promise<void> {
        this.isUpdating = true;
        return this.loadData()
            .then(() => {
                this.isUpdating = false;
            })
            .catch(err => {
                console.log('updateStore err: ', err);
                throw err;
            });
    }
}



// WEBPACK FOOTER //
// ./src/_stores/AbstractStore.ts